import { downgradeComponent } from '@angular/upgrade/static';
import { downgradedAngularModule } from 'src/ajs-app/app';
import { KakaotalkTemplateComponent } from './kakaotalk-templates/kakaotalk-template/kakaotalk-template.component';
import { MessageTemplatesComponent } from './message-templates.component';
import { WhatsappTemplateComponent } from './whatsapp-templates/whatsapp-template/whatsapp-template.component';

downgradedAngularModule
    .directive('angularMessageTemplates', downgradeComponent({ component: MessageTemplatesComponent }))
    .directive('angularWhatsappTemplate', downgradeComponent({ component: WhatsappTemplateComponent }))
    .directive('angularKakaotalkTemplate', downgradeComponent({ component: KakaotalkTemplateComponent }))
    ;